<div class="inline-block h-full">
  <img class="size-full object-contain" style="translate: -17% 0" src="assets/woordkr8/sprites/pipe-back.png" />
</div>
